// 플랫폼 판별 — 네이티브(Capacitor) vs 웹 분기의 단일 진입점.
// 웹에서는 Capacitor.isNativePlatform()이 false → 기존 웹 동작 그대로 유지.
import { Capacitor } from "@capacitor/core";

export const isNative = () => Capacitor.isNativePlatform();
export const getPlatform = () => Capacitor.getPlatform(); // 'web' | 'android' | 'ios'
export const isAndroid = () => Capacitor.getPlatform() === "android";
